import { useEffect, useState, useContext, useRef } from "react";
import { processJson } from ".";
import { AppContext } from './Launcher'
import stocksOptions from './dataset/stocks.json'

export const stockName = (id) => {
    const target = stocksOptions.filter(s => s.id === id)
    if (target.length > 0)
        return target[0].name
    else
        return '未知'
}


export const styleNumber = (v) => {
    if (v === undefined) {
        return { color: 'text-danger', number: '0' }
    }
    const color = v < 0 ? 'text-success' : 'text-danger'
    const number = v < 0 ? numberWithCommas(v) : '+' + numberWithCommas(v)
    return { color, number, v }
}

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const toDateString = (date) => {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();
    return [date.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join('-');
}

export const toTWDateString = (date) => {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();
    return [date.getFullYear() - 1911,
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join('/');
}

export const toTWDateStringOnlyNum = (date) => {
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();
    return [date.getFullYear() - 1911,
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join('');
}

export const toDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-")
    return new Date(year, month - 1, day)
}

const expire = 4 //避免 低於5秒連續呼叫

export const getTimestamp = () => Math.floor(Date.now() / 1000)

export const callTpexPZ = () => {
    const API_NAME = "TpexPZ"
    const now = getTimestamp()
    const url = 'https://www.tpex.org.tw/storage/emgstk/emgstk.txt'
    if (localStorage.getItem(API_NAME) === null ||
        JSON.parse(localStorage.getItem(API_NAME)).t < now - 60) { //超過一分鐘才更新
        if (window.Stockbook) {
            window.ApiReturnTime[API_NAME] = undefined
            window.Stockbook.fetch(API_NAME + ';' + url) //呼叫 native 取值       
        } else {
            fetch('https://cors-anywhere.herokuapp.com/' + url).then(response => {
                return response.json()
            }).then(data => {
                const apiRes = processJson(API_NAME, data)
                localStorage.setItem(API_NAME, JSON.stringify(apiRes))
            }).catch(err => {
                if (err.name === 'AbortError') {
                    console.log('Fetch aborted')
                } else {
                    console.error('Uh oh, an error!', err)
                }
            })
        }
    }
}

export const useDailyInfo = () => {
    const API_NAME = "DailyInfo"
    const [urls, setUrls] = useState('')
    const initDi = localStorage.getItem(API_NAME) ?
        JSON.parse(localStorage.getItem(API_NAME)).s : []
    const [d, setD] = useState(initDi)
    const { dispatchAppContext } = useContext(AppContext)

    useEffect(() => {
        const now = getTimestamp()
        if (urls) {
            if (window.Stockbook && window.Stockbook.fetchMulti) {
                let timer = null
                const chk = (ms) => {
                    if (window.ApiReturnTime[API_NAME]) {
                        dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                        const newD = JSON.parse(localStorage.getItem(API_NAME)).s
                        if (JSON.stringify(d) !== JSON.stringify(newD)) {
                            setD(newD)
                        }
                    } else {
                        timer = setTimeout(() => {
                            chk(1000)
                        }, ms)
                    }
                }

                if (typeof window.ApiReturnTime[API_NAME] === 'undefined' ||
                    window.ApiReturnTime[API_NAME] < now - expire) {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: true })
                    window.ApiReturnTime[API_NAME] = undefined
                    window.Stockbook.fetchMulti(API_NAME + ';' + urls.join(';')) //呼叫 native 取值
                    chk(5000)
                }
                return () => {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                    clearTimeout(timer)
                }
            } else {
                //for localhost testing     
                if (localStorage.getItem(API_NAME) === null ||
                    JSON.parse(localStorage.getItem(API_NAME)).t < now - expire) {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: true })
                    const controller = new AbortController()
                    const signal = controller.signal
                    let headers = new Headers();
                    headers.append('Access-Control-Allow-Origin', '*');
                    headers.append('Access-Control-Allow-Headers', 'Origin, X-Requested-With')
                    const delay = 2000
                    Promise.all(urls.map((url, i) => {
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                fetch(url, { signal, headers }).then(response => {
                                    resolve(response.json())
                                })
                            }, delay * i)
                        })
                    })).then(data => {
                        const simData = data.map(d => JSON.stringify(d))
                        dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                        const apiRes = processJson(API_NAME, simData)
                        localStorage.setItem(API_NAME, JSON.stringify(apiRes))
                        setD(apiRes.s)
                    }).catch(err => {
                        dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                        if (err.name === 'AbortError') {
                            console.log('Fetch aborted')
                        } else {
                            console.error('Uh oh, an error!', err)
                        }
                    })
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urls])
    return [d, setUrls]
}

export const useStockInfoPZ = () => {
    const API_NAME = 'StockInfoPZ'
    const [params, setParams] = useState('')
    const initPz = localStorage.getItem(API_NAME) ?
        JSON.parse(localStorage.getItem(API_NAME)).p : []
    const [pz, setPZ] = useState(initPz)
    const { dispatchAppContext } = useContext(AppContext)

    useEffect(() => {
        const now = getTimestamp()
        const paramLimit = 2000
        if (params) {
            if (window.Stockbook) {
                let timer = null
                const chk = (ms) => {
                    if (window.ApiReturnTime[API_NAME]) {
                        dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                        setPZ(JSON.parse(localStorage.getItem(API_NAME)).p)
                    } else {
                        timer = setTimeout(() => {
                            chk(500)
                        }, ms)
                    }
                }

                if (typeof window.ApiReturnTime[API_NAME] === 'undefined' ||
                    window.ApiReturnTime[API_NAME] < now - expire) {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: true })
                    if (params.length > paramLimit) { //超過API接受字串長度上限
                        if (window.Stockbook && window.Stockbook.fetchMulti) {
                            const url = 'https://mis.twse.com.tw/stock/api/getStockInfo.jsp?ex_ch='
                            let urls = []
                            const numOfReq = Math.ceil(params.length / paramLimit)
                            let initStr = params
                            for (let i = 0; i < numOfReq; i++) {
                                if (initStr.length > paramLimit) {
                                    let str = initStr.substring(0, paramLimit)
                                    let nxtStr = initStr.substring(paramLimit)
                                    if (!str.endsWith('.tw')) {
                                        nxtStr = str.substring(str.lastIndexOf('|') + 1) + nxtStr
                                        str = str.substring(0, str.lastIndexOf('.tw') + 3)
                                    } else {
                                        nxtStr = nxtStr.substring(1)
                                    }
                                    urls.push(url + str)
                                    initStr = nxtStr
                                } else {
                                    urls.push(url + initStr)
                                }
                            }
                            window.ApiReturnTime[API_NAME] = undefined
                            window.Stockbook.fetchMulti(API_NAME + ';' + urls.join(';'))
                        }
                    } else {
                        window.ApiReturnTime[API_NAME] = undefined
                        window.Stockbook.fetch(API_NAME + ';https://mis.twse.com.tw/stock/api/getStockInfo.jsp?ex_ch=' + params) //呼叫 native 取值
                    }
                    chk(3000)
                }
                return () => {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                    clearTimeout(timer)
                }
            } else {
                //for localhost testing
                if (localStorage.getItem(API_NAME) === null ||
                    JSON.parse(localStorage.getItem(API_NAME)).t < now - expire) {
                    dispatchAppContext({ type: "SET_API_CALLING", isCalling: true })
                    const controller = new AbortController()
                    const signal = controller.signal
                    let headers = new Headers();
                    headers.append('Access-Control-Allow-Origin', '*');
                    headers.append('Access-Control-Allow-Headers', 'Origin, X-Requested-With')
                    if (params.length > paramLimit) { //超過API接受字串長度上限
                        const url = 'https://cors-anywhere.herokuapp.com/http://mis.twse.com.tw/stock/api/getStockInfo.jsp?ex_ch='
                        let urls = []
                        const numOfReq = Math.ceil(params.length / paramLimit)
                        let initStr = params
                        for (let i = 0; i < numOfReq; i++) {
                            if (initStr.length > paramLimit) {
                                let str = initStr.substring(0, paramLimit)
                                let nxtStr = initStr.substring(paramLimit)
                                if (!str.endsWith('.tw')) {
                                    nxtStr = str.substring(str.lastIndexOf('|') + 1) + nxtStr
                                    str = str.substring(0, str.lastIndexOf('.tw') + 3)
                                } else {
                                    nxtStr = nxtStr.substring(1)
                                }
                                urls.push(url + str)
                                initStr = nxtStr
                            } else {
                                urls.push(url + initStr)
                            }
                        }
                        const delay = 2000
                        Promise.all(urls.map((url, i) => {
                            return new Promise((resolve) => {
                                setTimeout(() => {
                                    fetch(url, { signal, headers }).then(response => {
                                        resolve(response.json())
                                    })
                                }, delay * i)
                            })
                        })).then(data => {
                            console.log(data)
                            const simData = data.map(d => JSON.stringify(d))
                            let mergeData = { msgArray: [] }
                            simData.forEach(s => {
                                mergeData.msgArray = [...mergeData.msgArray, ...JSON.parse(s).msgArray]
                            })
                            console.log(mergeData)
                            dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                            const apiRes = processJson(API_NAME, mergeData)
                            localStorage.setItem(API_NAME, JSON.stringify(apiRes))
                            setPZ(apiRes.p)
                        })

                    } else {
                        const url = 'https://cors-anywhere.herokuapp.com/http://mis.twse.com.tw/stock/api/getStockInfo.jsp?ex_ch=' + params
                        fetch(url, { signal, headers }).then(response => {
                            return response.json()
                        }).then(data => {
                            dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                            const apiRes = processJson(API_NAME, data)
                            localStorage.setItem(API_NAME, JSON.stringify(apiRes))
                            setPZ(apiRes.p)
                        }).catch(err => {
                            dispatchAppContext({ type: "SET_API_CALLING", isCalling: false })
                            if (err.name === 'AbortError') {
                                console.log('Fetch aborted')
                            } else {
                                console.error('Uh oh, an error!', err)
                            }
                        })
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])
    return [pz, setParams]
}

export const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

export const exportToCsv = (filename, rows) => {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob(["\ufeff", csvFile], { type: 'text/csv;charset=utf-8' });
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
        var base64data = reader.result;
        if (isSupportFn('convertBase64StringToCsvAndStoreIt'))
            window.Stockbook.convertBase64StringToCsvAndStoreIt(base64data); //call native save            
    }
}

export const isSupportFn = (fnName) => {
    return (window.Stockbook && typeof window.Stockbook[fnName] === 'function')
}